export const AUTH_TOKEN = "authToken";
export const CANDIDATE_ROLE = "CANDIDATE";
export const EMPLOYER_ROLE = "EMPLOYER";
export const AUTHENTICATION = "AUTHENTICATION";
export const ROLE_EMPLOYER = 3;

export const MESSAGE_POLICY_ERROR =
  "Bạn cần đồng ý với điều khoản và chính sách của chúng tôi.";
